<script>
export default {
  name: 'Title',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    underlined: {
      type: Boolean,
      default: false,
    },
    removeVerticalMargin: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div
    :class="{ removeVerticalMargin: removeVerticalMargin }"
    class="title"
    v-on="$listeners"
  >
    <!-- TODO: Ajustar alinhamento do subtitulo -->
    <h1 v-if="title">
      {{ title }}
    </h1>
    <span v-if="subtitle">
      {{ subtitle }}
    </span>
    <div v-if="underlined" class="decoration-underline-title"></div>
  </div>
</template>

<style lang="sass" scoped>
@import '@design/components/_title.sass'

.removeVerticalMargin
  h1
    margin: 0px !important

  .decoration-underline-title
    bottom: -5px
    width: 88%
</style>
